import { fetchServices } from '@/api/service'
const getFlyToDay = (context) => {
  fetchServices().then((response) => {
    context.commit(
      'FLYTODAY_UPDATED',
      _.find(response, function (o) {
        return o.service_id == 2
      })
    )
  })
}

export default {
  getFlyToDay
}
